import request from "@/request";

export const getPermissionList = (params) =>
  request.get("/api/system/permissions/", { params });

export const getModelList = (params) =>
  request.get("/api/system/models/", { params });
